import { Storage } from "../../shared/utils/storageUtils";

const context = Storage.local.get("applicationContext", {
	__typename: "ApplicationContext",
	msisdn: "",
	subscriptionId: "",
	locale: "",
});

export { context };